import { Injectable } from "@angular/core";
import { FlagService } from "../../../services/flag.service";
import { PatchBase } from "../../patch/patches/patch-base";
import { EBTSFlag } from "../models/ebts-flag";
import { BackgroundTaskDatabaseService } from "../services/background-task-database.service";

@Injectable()
export class AddBtsMissingColumnsPatch extends PatchBase {
	//#region FIELDS

	private static readonly C_STORAGE_KEY = "add_bts_missing_columns_done";

	//#endregion

	//#region METHODS

	constructor(
		private readonly isvcBackgroundTaskDatabase: BackgroundTaskDatabaseService,
		private readonly isvcFlag: FlagService
	) {
		super("Ajout des colonnes manquantes dans la table BTS SQLite");
	}

	public override async applyPatchAsync(): Promise<boolean> {
		if (localStorage.getItem(AddBtsMissingColumnsPatch.C_STORAGE_KEY)) return true;

		try {
			await this.isvcFlag.waitForFlag(EBTSFlag.BTSDatabaseInitialized, true);
			await this.isvcBackgroundTaskDatabase.migrateSchemaAsync();
			localStorage.setItem(AddBtsMissingColumnsPatch.C_STORAGE_KEY, "ok");
			return true;
		} catch {
			return false;
		}
	}

	//#endregion
}
